var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrainings = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.268 1.155c.401.254.568.754.401 1.198L14.16 9.006l5.016.899a1 1 0 0 1 .543 1.679L8.986 22.694a1 1 0 0 1-1.67-1.004l2.182-6.699-4.686-.898a1 1 0 0 1-.531-1.677l10.733-11.11a1 1 0 0 1 1.254-.15ZM7.003 12.477l3.985.763a1 1 0 0 1 .763 1.292l-1.19 3.654 6.417-6.643-4.354-.78a1 1 0 0 1-.76-1.338l1.226-3.249-6.087 6.3Z",
  fill: "currentColor"
})));
export default SvgTrainings;